<template>
  <div>

    <b-table id="table_passages_coureur" responsive small :tbody-tr-class="row_arrivee" :items="estimation.sections"
      :fields="fields">
      <template #cell(distance_depuis_depart)="row">
        <span v-if="displayDistanceCell(row.item)">KM
          {{ Math.round(row.item.passage.distance_depuis_depart) }}</span>
      </template>
      <template #cell(nom_affiche)="row">
        <b>{{ nomAffiche(row.item) }}</b>
      </template>

      <template #cell(heure)="row">
        <span class="primary_color">{{ hasPassageHeure(row.item) ? heurePassage(row.item) :
          heureEstimatePassage(row.item) }}</span>
      </template>
      <template #cell(temps_intermediaire)="row">
        <span class="primary_color">{{ hasTempsIntermediaire(row.item) ? tempsIntermediaire(row.item) :
          tempsIntermediaireEstimate(row.item) }}</span>
      </template>
      <template #cell(temps_passage)="row">
        <span class="primary_color">{{ hasTempsPassage(row.item) ? tempsPassage(row.item) :
          tempsPassageEstimate(row.item) }}</span>
      </template>
      <template #cell(classement_scratch)="row">
        <DifferentielClt :classement="row.item.passage.classement_scratch"
          :differentiel="row.item.passage.differentiel_scratch">
        </DifferentielClt>
      </template>
      <template #cell(classement_sexe)="row">
        <DifferentielClt :classement="row.item.passage.classement_sexe"
          :differentiel="row.item.passage.differentiel_sexe">
        </DifferentielClt>
      </template>
      <template #cell(classement_cat)="row">
        <DifferentielClt :classement="row.item.passage.classement_cat"
          :differentiel="row.item.passage.differentiel_cat">
        </DifferentielClt>
      </template>
    </b-table>
    <p class="text-start"><span class="primary_color">*</span>L'estimation des temps intermédiaires est calculée à
      partir votre cotation <span v-if="type_estimation == 'itra'">ITRA</span><span v-else>Sportips</span> ainsi que du
      profil de course.</p>
    <hr />
  </div>
</template>

<script>
import DifferentielClt from "../FicheCoureur/Estimations/DifferentielClt.vue";
export default {
  components: {
    DifferentielClt,
  },
  props: ["cote_itra", "estimation", "statut_course"],
  data() {
    return {
      fields: [
        {
          key: "distance_depuis_depart",
          sortable: false,
          label: "Distance",
        },
        {
          key: "nom_affiche",
          sortable: false,
          label: "Nom",
        },
        {
          key: "heure",
          sortable: false,
          label: this.$t("heure_passage"),
        },
        {
          key: "temps_intermediaire",
          sortable: false,
          label: this.$t("temps_inter"),
        },
        {
          key: "temps_passage",
          sortable: false,
          label: this.$t("temps_course"),
        },
        {
          key: "classement_scratch",
          sortable: false,
          label: this.$t("scratch"),
        },
        { key: "classement_sexe", sortable: false, label: this.$t("sexe") },
        { key: "classement_cat", sortable: false, label: this.$t("cat") },
      ],
    };
  },
  methods: {
    row_arrivee(item, type) {
      if (!item || type !== "row") return;
      if (item.passage.nom_affiche.includes("Arrivée")) return "row-arrivee";
    },
    hasPassageHeure(item) {
      const nextPoint = item.passage;
      if (!nextPoint) return false;
      return nextPoint.heure && nextPoint.heure !== '00:00:00';
    },
    nextPointHasPassageHeure(item) {
      const sections = this.estimation.sections;
      if (!sections) return false;
      const index = sections.indexOf(item);
      if (index === -1 || index + 1 >= sections.length) return false;
      return this.hasPassageHeure(sections[index + 1]);
    },
    heureEstimatePassage(item) {

      if (this.nextPointHasPassageHeure(item) || this.statut_course_ended) {
        return "-";
      }
      if (this.has_no_estimation) {
        return "-";
      }
      if (item.over_estimation) {
        return "Arrivée imminente";
      }
      if (!item.heures_passage.estime_text) {
        return "-";
      }
      return `Estimée ${item.heures_passage.estime_text}*`;
    },

    heurePassage(item) {
      const nextPoint = item.passage;
      return nextPoint.heure;
    },
    hasTempsIntermediaire(item) {
      const nextPoint = item.passage;
      if (!nextPoint) return false;
      if (nextPoint.neutralise == 1) return true;
      return nextPoint.temps_intermediaire && nextPoint.temps_intermediaire !== '00:00:00';
    },
    tempsIntermediaire(item) {
      const nextPoint = item.passage;
      return nextPoint.temps_intermediaire;
    },
    tempsIntermediaireEstimate(item) {
      if (this.nextPointHasPassageHeure(item) || this.statut_course_ended) {
        return "-";
      }
      if (this.has_no_estimation) {
        return "-";
      }
      const hasPassageHeure = this.hasPassageHeure(item);
      if (hasPassageHeure) {
        return "-";
      }
      const estime_text = item.over_estimation ? item.temps_inter.over_estimation_text : item.temps_inter.estime_text;
      if (!estime_text) {
        return "-";
      }
      return `Estimé ${estime_text}*`;
    },
    hasTempsPassage(item) {
      const nextPoint = item.passage;
      if (!nextPoint) return false;
      return nextPoint.temps_passage && nextPoint.temps_passage !== '00:00:00';
    },
    tempsPassage(item) {
      const nextPoint = item.passage;
      return nextPoint.temps_passage;
    },
    tempsPassageEstimate(item) {
      if (this.nextPointHasPassageHeure(item) || this.statut_course_ended) {
        return "-";
      }
      if (this.has_no_estimation) {
        return "-";
      }
      const estime_text = item.over_estimation ? item.temps_course.over_estimation_text : item.temps_course.estime_text;
      if (!estime_text) {
        return "-";
      }
      return `Estimé ${estime_text}*`;
    },
    nomAffiche(item) {
      const nextPoint = item.passage;
      if (!nextPoint) return '';
      return nextPoint.nom_affiche || '';
    },
    displayDistanceCell(item) {
      const nextPoint = item.passage;
      if (!nextPoint) return false;
      const has_distance = nextPoint.distance_depuis_depart && nextPoint.distance_depuis_depart !== '0';
      const is_not_arrival = nextPoint.nom_affiche !== 'Arrivée';
      return has_distance && is_not_arrival;
    }
  },
  computed: {
    statut_course_ended() {
      return this.statut_course && this.statut_course.end;
    },
    has_no_estimation() {
      if (!this.estimation) return true;
      const type_estimation_sportips = this.type_estimation == 'sportips';
      const cotation_base = this.estimation.cotation == 445 || this.estimation.cotation == 377;
      const has_no_passage = this.estimation.sections[0].passage.ordre == '';

      return type_estimation_sportips && cotation_base && has_no_passage;
    },
    type_estimation() {
      if (this.cote_itra > 0) {
        return "itra";
      } else {
        return "sportips";
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>